import { zo } from 'remote/global';

const resetPasswordSchema = zo.object({
  email: zo.string().min(1).email(),
});

type ResetPasswordSchemaType = zo.infer<typeof resetPasswordSchema>;

export { resetPasswordSchema };
export type { ResetPasswordSchemaType };
